import { gql } from '@apollo/client';

const USER_FIELDS_WITH_CLIENTS = gql`
  fragment UserFieldsWithClients on User {
    id
    email
    name
    clientUsers {
      id
      admin
      client { id, name }
    }
  }
`;

export const USERS = gql`
  ${USER_FIELDS_WITH_CLIENTS}
  query Users (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    users (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...UserFieldsWithClients
        }
      }
      totalCount
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser ($input: InviteUserInput!) {
    inviteUser (input: $input) {
      user { id }
      errors { path, message }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser ($input: UpdateUserInput!) {
    updateUser (input: $input) {
      user { id }
      errors { path, message }
    }
  }
`;
